import { render, staticRenderFns } from "./CSVOrder.vue?vue&type=template&id=152330c2&"
import script from "./CSVOrder.vue?vue&type=script&lang=js&"
export * from "./CSVOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports